<p-card styleClass="service-indicator-card">
  <div class="service-indicator">
    <!-- Cabecera: identidad del servicio -->
    <div class="service-indicator__header">
      <p-avatar *ngIf="service.icon" [icon]="'pi ' + service.icon" shape="circle" styleClass="service-indicator__avatar"></p-avatar>
      <h3 class="service-indicator__name">{{ service.name }}</h3>
      <p-button
        icon="pi pi-info-circle"
        severity="secondary"
        variant="text"
        [rounded]="true"
        size="small"
        styleClass="service-indicator__hint"
        [pTooltip]="service.description"
        tooltipPosition="top"
        tooltipStyleClass="service-indicator__hint-tooltip"
        [ariaLabel]="'Acerca de ' + service.name"
      ></p-button>
    </div>

    <!-- Métricas -->
    <div class="service-indicator__metrics">
      <div class="service-indicator__metric">
        <span class="service-indicator__metric-label">Clientes</span>
        <ng-container *ngIf="!loading; else metricSkeleton">
          <p-tag value="{{ service.clientsCount }}" severity="info" [rounded]="true" styleClass="service-indicator__metric-value"></p-tag>
        </ng-container>
      </div>

      <p-divider layout="vertical" styleClass="service-indicator__metric-divider"></p-divider>

      <div class="service-indicator__metric">
        <span class="service-indicator__metric-label">Dispositivos</span>
        <ng-container *ngIf="!loading; else metricSkeleton">
          <p-tag value="{{ service.devicesCount }}" severity="contrast" [rounded]="true" styleClass="service-indicator__metric-value"></p-tag>
        </ng-container>
      </div>

      <ng-template #metricSkeleton>
        <!-- Mismo alto que el p-tag que reemplaza, para que la tarjeta no salte al cargar. -->
        <p-skeleton width="34px" height="20px" borderRadius="999px"></p-skeleton>
      </ng-template>
    </div>

    <p-divider styleClass="service-indicator__divider"></p-divider>

    <!-- Accesos, siempre en el mismo orden: Clientes -> Dispositivos -> Modelos -->
    <p-buttongroup class="service-indicator__actions">
      <p-button
        label="Clientes"
        icon="pi pi-users"
        iconPos="left"
        severity="secondary"
        [outlined]="true"
        size="small"
        [disabled]="!canManageClients"
        [pTooltip]="actionTooltip('clients')"
        tooltipPosition="bottom"
        (onClick)="onManageClients()"
      ></p-button>
      <p-button
        label="Dispositivos"
        icon="pi pi-box"
        iconPos="left"
        severity="secondary"
        [outlined]="true"
        size="small"
        [disabled]="!canManageDevices"
        [pTooltip]="actionTooltip('devices')"
        tooltipPosition="bottom"
        (onClick)="onManageDevices()"
      ></p-button>
      <p-button
        label="Modelos"
        icon="pi pi-list"
        iconPos="left"
        severity="secondary"
        [outlined]="true"
        size="small"
        [disabled]="!canManageModels"
        [pTooltip]="actionTooltip('models')"
        tooltipPosition="bottom"
        (onClick)="onManageModels()"
      ></p-button>
    </p-buttongroup>
  </div>
</p-card>
